/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IPublicSuburbanV1GetOffersHistorySpoilerRequest,
  TPublicSuburbanV1GetOffersHistorySpoilerModel,
  IMappers,
  TPublicSuburbanV1GetOffersHistorySpoilerResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOfferHistorySpoilerResponseV1 } from '../../../entities/offer_history/OfferHistorySpoilerResponseV1';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicSuburbanV1GetOffersHistorySpoilerModel(
  parameters: IPublicSuburbanV1GetOffersHistorySpoilerRequest,
): TPublicSuburbanV1GetOffersHistorySpoilerModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/suburban/v1/get-offers-history-spoiler/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IPublicSuburbanV1GetOffersHistorySpoilerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1GetOffersHistorySpoilerRequest;
}

export async function fetchPublicSuburbanV1GetOffersHistorySpoiler<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1GetOffersHistorySpoilerOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicSuburbanV1GetOffersHistorySpoilerResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicSuburbanV1GetOffersHistorySpoilerModel(parameters),
    config,
  )) as FetchResponse<TPublicSuburbanV1GetOffersHistorySpoilerResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferHistorySpoilerResponseV1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicSuburbanV1GetOffersHistorySpoilerResponse>;
}
